import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NotionState {
  token: string;
  enabled: boolean;
  /** quando true, todas as gerações do pipeline buscam contexto no Notion */
  injectInGeneration: boolean;
  setToken: (t: string) => void;
  setEnabled: (b: boolean) => void;
  setInject: (b: boolean) => void;
}

const envToken = (import.meta as any).env?.VITE_NOTION_TOKEN as string | undefined;

export const useNotion = create<NotionState>()(
  persist(
    (set) => ({
      token: envToken?.trim() || "",
      enabled: !!envToken?.trim(),
      injectInGeneration: false,
      setToken: (token) => set({ token }),
      setEnabled: (enabled) => set({ enabled }),
      setInject: (injectInGeneration) => set({ injectInGeneration })
    }),
    { name: "agencia-vpc-notion-v1" }
  )
);
